<ng-container>
    <div class="overlay-warp">
        <div (click)="selectCategory(category.category.id)" class="item" *ngFor="let category of categoriesList" [ngClass]="{'selected':category.category.id == categoryIdFromSelectedFilter }">
            <p translate [translateParams]="{ category: category.category}">grid.categoryName</p> 
            <p class="count">{{category.count}}</p>
        </div>
    </div>
</ng-container>